module.exports = __webpack_public_path__ + "img/common_DEP.64b72331.svg";